import { useState } from 'react'

const DebugJson = (json: any) => {
  const debugP2 = process.env.REACT_APP_DEBUG_P2 === 'true' ? true : false

  const [showJson, setShowJson] = useState(false)

  if (!debugP2) return null

  return (
    <>
      {!showJson ? (
        <button
          onClick={() => setShowJson(!showJson)}
          style={{ color: 'white', textDecoration: 'underline' }}
        >
          Show Json
        </button>
      ) : (
        <div>
          <hr />
          <pre>{JSON.stringify(json, null, 2)}</pre>
        </div>
      )}
    </>
  )
}

export default DebugJson
